<template>
    <div class="flex items-center h-full border-l border-gray-200 bg-gray-100 transition duration-300 | focus-within:bg-white">
        <input
            v-bind="$attrs"
            class="bg-transparent p-6 transition duration-300 | focus:bg-white"
            type="text"
            :value="value"
            @input="$emit('input', $event.target.value)"
        >
        <nio-icon class="mr-6 -mt-1 text-gray-600" name="regular/search" />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                required: true,
            },
        },
    };
</script>
